<template>
    <table class="selected_table">
        <tr>
            <th>ブランド事業者名</th>
            <td>{{ selectedData.brandCompanyName }}</td>
        </tr>
        <tr v-if="selectedData.systemNumber != undefined">
            <th>システム形式</th>
            <td>{{ selectedData.systemNumber }}</td>
        </tr>
        <tr v-if="selectedData.powerUnitNumber != undefined">
            <th>ヒートポンプユニット形式</th>
            <td>{{ selectedData.powerUnitNumber }}</td>
        </tr>
        <tr v-if="selectedData.heatPumpUnitNumber != undefined">
            <th>ヒートポンプユニット番号</th>
            <td>{{ selectedData.heatPumpUnitNumber }}</td>
        </tr>
        <tr>
            <th>{{ tankUnitNumberName() }}</th>
            <td>{{ selectedData.tankUnitNumber }}</td>
        </tr>
        <tr v-if="selectedData.backupBoilerNumber != undefined">
            <th>補助熱源機品番</th>
            <td>{{ selectedData.backupBoilerNumber }}</td>
        </tr>
        <tr>
            <th>成績証明書番号または自己適合宣言書番号</th>
            <td>{{ selectedData.certificationNumber }}</td>
        </tr>
    </table>
</template>

<script>
/**
 * [プロパティ]
 * selectedData ... 選択された機器情報
 * 
 * [利用例]
 * <selected-hot-water-table :selectedData="選択した検索結果"/>
 */
export default {
    name:"SelectedHotWaterTable",
    props: {
        /**
         * 選択された機器情報のObjectがそのまま入る
         */
        selectedData:{
            type:Object
        },
    },
    methods:{
        tankUnitNumberName(){
            return this.selectedData.systemNumber != undefined ? '貯湯ユニット形式' : '貯湯ユニット品番'
        }
    }
}
</script>

<style scoped>
.selected_table{
    width: 100%;
    margin: 5px 10px;
}
.selected_table th{
    font-weight: 600;
    width: 50%;
}
</style>
